import useSWR from 'swr';

import { fetchTemplateHistory, type TemplateOccurrence } from '../data/recurringRepository.js';

export const templateHistoryKey = (templateId: string, from: string, to: string) =>
  `recurring-history/${templateId}/${from}/${to}`;

export type TemplateHistoryState =
  | { status: 'loading' }
  | { status: 'error'; message: string; retry: () => void }
  | { status: 'ready'; rows: readonly TemplateOccurrence[]; refresh: () => Promise<unknown> };

/** The occurrences of one template in a range — what /dinh-ky/:templateId shows (AJ3). */
export function useTemplateHistory(
  templateId: string,
  from: string,
  to: string,
): TemplateHistoryState {
  const { data, error, isLoading, mutate } = useSWR<readonly TemplateOccurrence[], Error>(
    templateHistoryKey(templateId, from, to),
    () => fetchTemplateHistory(templateId, from, to),
    { revalidateOnFocus: false, shouldRetryOnError: false },
  );
  if (error) {
    return {
      status: 'error',
      message: error.message || 'Không tải được lịch sử khoản định kỳ.',
      retry: () => {
        void mutate();
      },
    };
  }
  if (isLoading || data === undefined) return { status: 'loading' };
  return { status: 'ready', rows: data, refresh: () => mutate() };
}
